import React from 'react';

const AWS_Cost_Explorer = () => {
  return (
    <div>
      <h1>AWS_Cost_Explorer</h1>
      <p>This is the AWS_Cost_Explorer component.</p>
    </div>
  );
};

export default AWS_Cost_Explorer;
